import CartCard from "../../components/CartCard";
import {
  Container,
  Typography,
  Button,
  Badge,
  Stack,
  Box,
  LinearProgress,
} from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { confirmAlert } from "react-confirm-alert"; // Import confirm alert library
import "react-confirm-alert/src/react-confirm-alert.css"; // Import CSS styles for the alert
import "./cart.css";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { userState, dispatch } = useContext(UserContext); // Access user state and dispatch function from context
  const cartProducts = userState.cart.products; // Get the products in the cart
  const [showCongrats, setShowCongrats] = useState(false); // State to show the success modal
  const [progress, setProgress] = useState(100); // Progress bar state for the success modal
  const navigate = useNavigate(); // Navigation hook for redirection

  useEffect(() => {
    // Redirect to login page if the user is not logged in
    if (!userState?.username) {
      navigate("/login");
    }
  }, [userState, navigate]);

  const handleCheckout = () => {
    // Show a confirmation alert before proceeding with checkout
    confirmAlert({
      title: "Checkout confirmation",
      message: `Just to confirm—you're about to purchase all the items in your cart for a total of $${userState.cart.total}. Would you like to continue?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            setShowCongrats(true); // Show the success modal
            setProgress(100); // Reset progress bar

            // Create an interval to decrease progress gradually
            const interval = setInterval(() => {
              setProgress((prevProgress) =>
                prevProgress > 0 ? prevProgress - 1 : 0
              );
            }, 60);

            // Dispatch checkout action to update state
            dispatch({
              type: "checkout",
              payload: userState.cart.products,
            });

            // Hide the success modal after 7 seconds
            setTimeout(() => {
              setShowCongrats(false);
              clearInterval(interval);
            }, 7000);
          },
        },
        {
          label: "No", // Do nothing if the user cancels
        },
      ],
    });
  };

  return (
    <Container
      sx={{
        marginTop: "100px",
        marginBottom: "30px",
        width: { xs: "90%", sm: "80%", md: "70%", lg: "60%" },
        minHeight: "60vh",
      }}
    >
      <Stack>
        {/* Cart title section with badge displaying item count */}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: "white",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            color="white"
            sx={{ marginRight: "15px" }}
          >
            <Badge
              badgeContent={userState.cart.amount}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "red",
                  color: "white",
                  fontSize: "12px",
                },
              }}
            >
              <ShoppingCart />
            </Badge>{" "}
          </Typography>
          <Typography variant="h5">My Cart</Typography>
        </Stack>
        <Typography
          color="text.secondary"
          sx={{ marginTop: "4px", marginBottom: "15px" }}
        >
          {userState.cart.amount} Items
        </Typography>
      </Stack>

      {/* Render all cart products */}
      {cartProducts.map((product, index) => (
        <CartCard key={index} product={product} />
      ))}

      {/* Display total price */}
      <Typography
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
        }}
      >
        Total: ${userState.cart.total}
      </Typography>

      {/* Checkout button */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={userState.cart.amount === 0} // Disable button if cart is empty
        sx={{ mt: 2 }}
        onClick={handleCheckout}
      >
        Checkout
      </Button>

      {/* Success modal when checkout is completed */}
      {showCongrats && (
        <Box className="congrats-modal">
          {/* Progress bar animation */}
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              position: "absolute",
              top: "2px",
              left: "50%",
              width: "97%",
              borderRadius: "20%",
              height: "3px",
              transform: "translateX(-50%)",
              backgroundColor: "transparent",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "primary.main",
              },
            }}
          />
          <CheckBoxIcon color="primary" />
          <Typography>
            Congratulations! Your purchase is complete. Thank you for shopping
            with us!
          </Typography>
          <Button onClick={() => setShowCongrats(false)}>OK</Button>
        </Box>
      )}
    </Container>
  );
};

export default Cart;
